import Vue from 'vue';

import Vuesax from 'vuesax'; // Vuesax Component Framework
import 'vuesax/dist/vuesax.css' //Vuesax styles
import 'material-icons/iconfont/material-icons.css'; // Material Icons
import colors from './colors';
import FlatPickr from 'vue-flatpickr-component'; // DateTime Picker
import 'flatpickr/dist/flatpickr.css';
import VCalendar from 'v-calendar'; // DatePicker

import Validator from 'components/Validator';
import { ValidationProvider, ValidationObserver, getFirstErrorMessage, hasError } from 'utils/validator';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import App from './App.vue';
import router from './router';
import store from './store';
import './assets/scss/style.scss';

import FormatUtil from 'utils/format';

import VueGtm from 'vue-gtm';
import VueGtag from 'vue-gtag'
import { endsWith } from 'lodash';
import * as amplitude from  '@amplitude/analytics-browser'

import config from './config';

const AMPLITUDE_API_KEY = config.amplitude.apiKey;

amplitude.init(AMPLITUDE_API_KEY, undefined, {
  logLevel: amplitude.Types.LogLevel.Warn,
  defaultTracking: {
    sessions: true,
  },
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('Validator', Validator);
Vue.component('v-select', vSelect);
Vue.use(VCalendar);
Vue.config.productionTip = false;
Vue.use(Vuesax, { theme: { colors } });
Vue.use(FlatPickr);
Vue.use(VueGtag, {
  config: {
    id: 'G-R11YXY6K9D'
  }
}, router)

if (endsWith(window.location.host, 'socar.kr')) {
  Vue.use(VueGtm, {
    id: 'GTM-KQ2NQTB', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
    defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: ['homepage'], // If router, you can exclude some routes name (case insensitive) (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  });
}

Vue.prototype.getFirstErrorMessage = (validator, defaultText) => getFirstErrorMessage(validator, defaultText);
Vue.prototype.hasError = (errors, fieldName) => hasError(errors, fieldName);
Vue.prototype.formatNumber = (num) => FormatUtil.formatNumber(num);
Vue.prototype.formatDate = (date, format) => FormatUtil.formatDate(date, format);
Vue.prototype.formatDateTime = (date, format) => FormatUtil.formatDateTime(date, format);


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
